import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { MySurveysPageIndexDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { FormRender } from 'modules/forms'
import { FormResponsesSidepanel } from 'modules/forms/components/FormResponses/FormRenderResponses/FormResponsesSidepanel'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { MySurveysDataCollection } from 'modules/trainings/components/MyTrainings/MySurveys/MySurveysDataCollection'

const Surveys = () => {
  const { data, loading, error } = useQuery(MySurveysPageIndexDocument)
  const [currentForm, setCurrentForm] = useState<
    | {
        formId: string
        resourceId: string
        membershipId: string
        formType: string
        materializedFormId: string
        hasPreviousAnswers: boolean
        respondentId?: string | undefined
      }
    | undefined
  >(undefined)
  const [openSidepanel, setOpenSidepanel] = useState(false)
  const [refetchSurveys, setRefetchSurveys] = useState<() => void>(() => {})
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const onSubmitSuccess = () => {
    if (currentForm?.formType === 'knowledge') {
      navigate(
        navigation.myTrainings.surveys.score.fullPath({
          membership_id: String(currentForm.membershipId),
          materialized_form_id: String(currentForm.materializedFormId),
        })
      )
    } else {
      refetchSurveys()
    }
  }
  return (
    <ResponsivePage.Body loading={loading} error={error} variant="full">
      <MySurveysDataCollection
        setCurrentForm={setCurrentForm}
        setOpenSidepanel={() => setOpenSidepanel(true)}
        onRefetch={(refetch) => {
          setRefetchSurveys(() => refetch)
        }}
      />
      {currentForm && !currentForm.hasPreviousAnswers && (
        <FormRender
          formId={currentForm?.formId}
          resourceType="Trainings::Training"
          onClose={() => setOpenSidepanel(false)}
          onSubmitSuccess={() => {
            onSubmitSuccess()
          }}
          isOpen={openSidepanel}
          mode="answer"
          resourceHeaderModule={{
            href: navigation.myTrainings.surveys.fullPath(),
            id: 'my_trainings',
            label: i18n.t('trainings.my_training.surveys'),
          }}
          membershipId={currentForm.membershipId}
        />
      )}
      {currentForm && currentForm.hasPreviousAnswers && (
        <FormResponsesSidepanel
          formId={currentForm.formId}
          membershipId={currentForm.membershipId}
          resourceType="Trainings::Training"
          materializedFormResourceType="Trainings::TrainingClass"
          isOpen={openSidepanel}
          onClose={() => setOpenSidepanel(false)}
          resourceHeaderModule={{
            href: navigation.myTrainings.surveys.fullPath(),
            id: 'my_trainings',
            label: i18n.t('trainings.my_training.surveys'),
          }}
          respondentId={currentForm?.respondentId}
        />
      )}
    </ResponsivePage.Body>
  )
}
export default Surveys
